import React from 'react';
import { bool, func } from 'prop-types';
import { ExitToApp } from '@material-ui/icons';
import {
  IconButton,
  Tooltip,
} from '@material-ui/core';

import { useAppContext } from 'Scenes/_root/appContext';

const Logout = ({ hasChimeMeeting, locationPractitionerLogin }) => {
  const { isAuthenticating, logout } = useAppContext();
  return (
    <Tooltip placement='top' title='Logout'>
      <span>
        <IconButton
          disabled={isAuthenticating || hasChimeMeeting}
          edge="end"
          onClick={() => logout(locationPractitionerLogin)}
        >
          <ExitToApp />
        </IconButton>
      </span>
    </Tooltip>
  );
};

const MapStateProps = {
  hasChimeMeeting: bool.isRequired,
};

const MapDispatchProps = {
  locationPractitionerLogin: func.isRequired,
};

Logout.propTypes = {
  ...MapStateProps,
  ...MapDispatchProps,
};

export default Logout;
